(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["prime-product-description"] && !Shopify.designMode) return;
  try {
    (function () {
  const componentSelector = '[data-prime-description]';
  const contentSelector = '[data-prime-description-content]';
  const buttonSelector = '[data-prime-description-toggle]';

  function getCollapsedHeight(component) {
    const value = parseInt(component.dataset.collapsedHeight, 10);
    return Number.isFinite(value) ? value : 800;
  }

  function setButtonState(button, expanded) {
    button.setAttribute('aria-expanded', String(expanded));
    button.textContent = expanded
      ? button.dataset.collapseLabel
      : button.dataset.expandLabel;
  }

  function prepareComponent(component) {
    if (component.dataset.primeDescriptionInitialized === 'true') {
      return;
    }

    const content = component.querySelector(contentSelector);
    const button = component.querySelector(buttonSelector);

    if (!content || !button) {
      return;
    }

    component.dataset.primeDescriptionInitialized = 'true';

    const collapsedHeight = getCollapsedHeight(component);

    content.style.maxHeight = 'none';

    const fullHeight = content.scrollHeight;

    if (fullHeight <= collapsedHeight + 2) {
      button.hidden = true;
      content.style.maxHeight = '';
      return;
    }

    component.classList.add('is-collapsible');
    component.classList.remove('is-expanded');

    content.style.maxHeight = collapsedHeight + 'px';

    button.hidden = false;
    setButtonState(button, false);

    button.addEventListener('click', function () {
      const isExpanded = component.classList.contains('is-expanded');

      if (!isExpanded) {
        component.classList.add('is-expanded');

        content.style.maxHeight = content.scrollHeight + 'px';

        setButtonState(button, true);

        window.setTimeout(function () {
          if (component.classList.contains('is-expanded')) {
            content.style.maxHeight = 'none';
          }
        }, 420);

        return;
      }

      const componentTop =
        component.getBoundingClientRect().top + window.scrollY;

      content.style.maxHeight = content.scrollHeight + 'px';

      content.offsetHeight;

      component.classList.remove('is-expanded');

      content.style.maxHeight = collapsedHeight + 'px';

      setButtonState(button, false);

      if (window.scrollY > componentTop) {
        const reduceMotion = window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches;

        window.scrollTo({
          top: Math.max(0, componentTop - 24),
          behavior: reduceMotion ? 'auto' : 'smooth'
        });
      }
    });
  }

  function initPrimeDescriptions(root) {
    const scope = root || document;

    scope.querySelectorAll(componentSelector).forEach(prepareComponent);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initPrimeDescriptions(document);
    });
  } else {
    initPrimeDescriptions(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initPrimeDescriptions(event.target);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
